/**
 * usePageView Hook
 * Tracks page views automatically on route changes.
 * Place this once at the router level — it handles everything.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

/**
 * Tracks a page view every time the route changes.
 * Deduplicates so the same path isn't tracked twice in a row.
 */
export function usePageView(): void {
  const location = useLocation();
  const lastTrackedPath = useRef<string>('');

  useEffect(() => {
    const path = location.pathname;

    // Don't track the same path twice in a row (e.g., re-renders)
    if (path === lastTrackedPath.current) return;
    lastTrackedPath.current = path;

    trackPageView(path);
  }, [location.pathname]);
}
